import { Typography, TypographyProps } from '@mui/material';
import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from 'stores/storeInitializer';

export interface MTypographyProps extends TypographyProps {
    children: LocalizationKeys;
    values?: (string | number)[];
    hidden?: boolean;
}

export const MTypography: React.FC<MTypographyProps> = observer(
    ({ values, ...props }) => {
        const { store } = useStores();
        const text = values && values.length > 0 ?
            store.L(props.children, ...values) :
            store.L(props.children);
        return <Typography {...props}>{props.hidden ? '' : text}</Typography>;
    },
);
